import { abyssColors } from '@/theme/colors';
import { Box, Stack, Switch } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';

export const poiTabStyles = {
  width: 'fit-content',
  minHeight: 'fit-content',
  background: abyssColors.tertiary[50],
  '& .MuiTabs-flexContainer': {
    width: 'fit-content',
    gap: '2.4rem',
  },
  '& .MuiTab-root': {
    width: 'fit-content',
    padding: '1.6rem 2.2rem',
    fontSize: '1.4rem',
    fontStyle: 'normal',
    fontWeight: 400,
    minWidth: 'fit-content',
    minHeight: 'fit-content',
    textTransform: 'none',
    lineHeight: '1.6rem',
    color: `${abyssColors.primary[400]} !important`,
    flexGrow: 0,
  },
  '& .MuiTab-root.Mui-selected': {
    color: `${abyssColors.primary[500]} !important`,
    fontWeight: 500,
  },
  '& .MuiTab-textColorPrimary': {
    color: abyssColors.primary[400],
  },
  '& .MuiTabs-indicator': {
    backgroundColor: abyssColors.primary[500],
    height: '0.4rem',
    borderRadius: '0.8rem',
    zIndex: 2,
  },
};

export const FloatingLine = muiStyled(Box)(() => ({
  borderTop: `0.1rem solid ${abyssColors.primary[200]}`,
  width: '100%',
  position: 'relative',
  bottom: '0.3rem',
  zIndex: '1',
  opacity: 0.5,
}));

export const FullWidthPanel = muiStyled(Stack)(() => ({
  width: '100%',
  padding: '3.2rem',
  marginTop: '2rem',
  flex: 1,
  background: abyssColors.primary[50],
  gap: '3.2rem',
  flexDirection: 'row',
}));

export const CustomSwitch = muiStyled(Switch)(() => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#2690ca',
    '&:hover': {
      backgroundColor: 'rgba(38, 144, 202, 0.08)',
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: '#82badb',
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#999a9c',
  },
  '& .MuiSwitch-thumb': {
    boxShadow:
      '0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.20)',
  },
}));
